/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidateEmailIndex } from '../../axios/candidateEmailIndex'
import type {
	CandidateEmailIndexError,
	CandidateEmailIndexPathParams,
	CandidateEmailIndexResponse,
} from '../../types/CandidateEmailIndex'

export const candidateEmailIndexQueryKey = (candidateId: CandidateEmailIndexPathParams['candidateId']) =>
	[{ url: '/candidates/:candidateId/emails', params: { candidateId } }] as const

export type CandidateEmailIndexQueryKey = ReturnType<typeof candidateEmailIndexQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateEmailController.php CandidateEmailController::index */
export function candidateEmailIndexQueryOptions(
	candidateId: CandidateEmailIndexPathParams['candidateId'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		CandidateEmailIndexResponse,
		AxiosError<CandidateEmailIndexError>,
		CandidateEmailIndexResponse,
		CandidateEmailIndexQueryKey
	>({
		queryKey: candidateEmailIndexQueryKey(candidateId),
		queryFn: ({ signal }) => candidateEmailIndex(candidateId, { signal, ...config }).then(res => res.data),
		enabled: !!candidateId,
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateEmailController.php CandidateEmailController::index */
export function useCandidateEmailIndex<TSelectData = CandidateEmailIndexResponse>(
	candidateId: CandidateEmailIndexPathParams['candidateId'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CandidateEmailIndexResponse,
					AxiosError<CandidateEmailIndexError>,
					TSelectData,
					CandidateEmailIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CandidateEmailIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...candidateEmailIndexQueryOptions(candidateId),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateEmailController.php CandidateEmailController::index */
export function useCandidateEmailIndexSuspense<TSelectData = CandidateEmailIndexResponse>(
	candidateId: CandidateEmailIndexPathParams['candidateId'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CandidateEmailIndexResponse,
					AxiosError<CandidateEmailIndexError>,
					TSelectData,
					CandidateEmailIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CandidateEmailIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...candidateEmailIndexQueryOptions(candidateId),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
